<template>
  <div class="card ace_sec" aria-label="Notes">
    <div class="card-header rgt_ic">
      <span class="ic ico-notes action-icon-note float-left text-center mr-2 mt-1"></span>
      <span class="label ace_sec_hd" role="heading" aria-level="1" aria-label="Notes">
        {{ $tf('notes') }}
      </span>
      <b-btn class="btn_ic float-right" aria-hidden="true" aria-label="Create Note" @click="showAdvisorNoteModal">
        <span class="fa fa-plus"></span>
      </b-btn>
    </div>
    <div class="card-body">
      <b-tabs v-model="tabIndex" content-class="" justified>
        <b-tab title="Private" :title-link-class="linkClass(0)" @click="loadPrivateChannelMessage">
          <div class="channel-section">
            <div class="msg_row_section">
              <div class="msg_section_inner">

                <div class="chat-message" style="margin-bottom: 2px;" v-for="message in messages">
                  <div class="message-avatar-default">
                    <span class="icon-user"></span>
                  </div>
                  <div class="message-details">
                    <div class="message-author-name">
                      <span class="message-author">{{message.name}}</span>
                      <span class="message-time message-time float-right">{{get12HourTime(message.date)}}</span>
                    </div>
                    <div class="message">
                      <div class="message-content float-left" v-html="message.text"></div>
                    </div>
                  </div>
                </div>

                <div class="no_data" v-if="messages.length === 0">
                  Add notes that are visible only to you
                </div>

              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Shared" :title-link-class="linkClass(1)" @click="loadSharedChannelMessage">
          <div class="channel-section">
            <div class="msg_row_section">
              <div class="msg_section_inner">

                <div class="chat-message" style="margin-bottom: 2px;" v-for="message in messages">
                  <div class="message-avatar-default">
                    <span class="icon-user"></span>
                  </div>
                  <div class="message-details">
                    <div class="message-author-name">
                      <span class="message-author">{{message.name}}</span>
                      <span class="message-time message-time float-right">{{get12HourTime(message.date)}}</span>
                    </div>
                    <div class="message">
                      <div class="message-content float-left" v-html="message.text"></div>
                    </div>
                  </div>
                </div>

                <div class="no_data" v-if="messages.length === 0">
                  Add notes that can be seen by all advisors
                </div>

              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { db } from '../../../firebase'

  export default {
    name: 'advisee-note',
    props: ['advisee'],
    data: () => {
      return {
        tabIndex: 1,
        messages: [],
        channelId: '',
        noteTypeUserChannelIdMap: {}
      }
    },
    mounted () {
      let userUuid = this.advisee.userId
      this.loadAdvisorChannelIdsForSelectedUsers([userUuid]).then(resp => {
        this.noteTypeUserChannelIdMap = resp
        let userChannelIdMap = this.noteTypeUserChannelIdMap['Shared']
        this.channelId = userChannelIdMap[userUuid]
        this.$bindAsArray('messages', db.ref('channels/' + this.channelId + '/Messages'))
      })
    },
    methods: {
      ...mapActions([
        'loadAdvisorChannelIdsForSelectedUsers'
      ]),
      scrollToLastMessage () {
        setTimeout(() => {
          let scrollTo = 0
          let container = $('.msg_row_section')
          let children = $('.msg_section_inner').children()
          for (let i = 0; i < children.length; i++) {
            let elem = children.eq(i)
            scrollTo += ($(elem).innerHeight() + 15)
          }
          container.scrollTop(scrollTo)
        }, 100)
      },
      showAdvisorNoteModal () {
        this.$parent.$refs.advisorNoteActionMenu.selectedNoteType = this.$parent.selectedNoteType
        this.$parent.$refs.advisorNoteActionMenu.viewNote()
      },
      loadSharedChannelMessage () {
        this.$parent.selectedNoteType = 'Shared'
        let userUuid = this.advisee.userId
        let userChannelIdMap = this.noteTypeUserChannelIdMap['Shared']
        this.channelId = userChannelIdMap[userUuid]
        this.$bindAsArray('messages', db.ref('channels/' + this.channelId + '/Messages'))
      },
      loadPrivateChannelMessage () {
        this.$parent.selectedNoteType = 'Private'
        let userUuid = this.advisee.userId
        let userChannelIdMap = this.noteTypeUserChannelIdMap['Private']
        this.channelId = userChannelIdMap[userUuid]
        this.$bindAsArray('messages', db.ref('channels/' + this.channelId + '/Messages'))
      },
      linkClass (idx) {
        if (this.tabIndex === idx) {
          return ['active']
        } else {
          return ['bg-primary', 'text-light']
        }
      },
      get12HourTime (datetime) {
        let values = datetime.split(' ')
        let hrmn = values[1].split(':')
        let hr = hrmn[0]
        let mn = hrmn[1]
        let ampm = hr >= 12 ? 'pm' : 'am'
        hr = hr % 12
        hr = hr ? hr : 12
        let time = values[0] + ' ' + hr + ':' + mn + ' ' + ampm
        return time
      }
    },
    watch: {
      messages () {
        this.scrollToLastMessage()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/AdviseeNote.vue